export class TypeTache {

    id: string;
    parent: string;
    libelle: string;
    metier_gerance: boolean;
    metier_syndic: boolean;
    metier_transaction: boolean;
    metier_immo: boolean;
    metier_projet: boolean;
    metier_autres: boolean;
    metier_tous: boolean;
    activated: boolean;
    default: boolean;
    extranet: boolean;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }
        this.id                     = data['id'] ? data['id'] : null;
        this.parent                 = data['parent'] ? data['parent'] : null;
        this.libelle                = data['libelle'] ? data['libelle'] : null;
        this.metier_gerance         = data['metier_gerance'] ? data['metier_gerance'] : true;
        this.metier_syndic          = data['metier_syndic'] ? data['metier_syndic'] : true;
        this.metier_transaction     = data['metier_transaction'] ? data['metier_transaction'] : true;
        this.metier_immo            = data['metier_immo'] ? data['metier_immo'] : true;
        this.metier_projet          = data['metier_projet'] ? data['metier_projet'] : true;
        this.metier_autres          = data['metier_autres'] ? data['metier_autres'] : true;
        this.metier_tous            = data['metier_tous'] ? data['metier_tous'] : true;
        this.activated              = data['activated'] ? data['activated'] : true;
        this.default                = data['default'] ? data['default'] : true;
        this.extranet               = data['extranet'] ? data['extranet'] : true;
    }
}
